import { useSelector } from 'react-redux';

import {
  selectHasAudioSubscription,
  selectHasImagesSubscription,
  selectHasVideoSubscription,
} from '../../auth/AuthSelectors';
import AudioSiteConstants from '../../common/SiteConstants/AudioSiteConstants';
import ImageSiteConstants from '../../common/SiteConstants/ImageSiteConstants';
import VideoSiteConstants from '../../common/SiteConstants/VideoSiteConstants';

export default function useUpgradeUrl() {
  const videoSubscriptionId = useSelector(selectHasVideoSubscription)?.uniqueId;
  const audioSubscriptionId = useSelector(selectHasAudioSubscription)?.uniqueId;
  const imageSubscriptionId = useSelector(selectHasImagesSubscription)
    ?.uniqueId;

  if (videoSubscriptionId) {
    return `${new VideoSiteConstants().getUpgradeMyPlanBasePath()}/${videoSubscriptionId}`;
  } else if (audioSubscriptionId) {
    return `${new AudioSiteConstants().getUpgradeMyPlanBasePath()}/${audioSubscriptionId}`;
  } else if (imageSubscriptionId) {
    return `${new ImageSiteConstants().getUpgradeMyPlanBasePath()}/${imageSubscriptionId}`;
  }

  return '/pricing';
}
